var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "q-page",
    { attrs: { padding: "" } },
    [
      _c(
        "div",
        { staticClass: "q-display-1 q-mb-md text-secondary" },
        [
          _c("q-icon", {
            staticClass: "q-mb-sm",
            attrs: { name: "far fa-calendar-alt" }
          }),
          _vm._v(" " + _vm._s(_vm.$t("calendar")) + "\n    ")
        ],
        1
      ),
      _c("div", { staticClass: "row gutter-sm q-mb-lg" }, [
        _c(
          "div",
          { staticClass: "col-xs-12 col-sm-12" },
          [
            _c("q-input", {
              ref: "title",
              attrs: {
                "float-label": _vm.$t("title"),
                error: _vm.$v.title.$error,
                disable: _vm.disableFields
              },
              on: { input: _vm.$v.title.$touch },
              model: {
                value: _vm.title,
                callback: function($$v) {
                  _vm.title = $$v
                },
                expression: "title"
              }
            })
          ],
          1
        )
      ]),
      _c("div", { staticClass: "row gutter-sm q-mb-lg" }, [
        _c(
          "div",
          { staticClass: "col-xs-12 col-sm-6" },
          [
            _c("q-datetime", {
              ref: "date_start",
              attrs: {
                type: "datetime",
                "float-label": _vm.$t("date_start"),
                format: "DD/MM/YYYY HH:mm:ss",
                error: _vm.$v.date_start.$error
              },
              on: { input: _vm.$v.date_start.$touch },
              model: {
                value: _vm.date_start,
                callback: function($$v) {
                  _vm.date_start = $$v
                },
                expression: "date_start"
              }
            })
          ],
          1
        ),
        _c(
          "div",
          { staticClass: "col-xs-12 col-sm-6" },
          [
            _c("q-datetime", {
              ref: "date_end",
              attrs: {
                type: "datetime",
                "float-label": _vm.$t("date_end"),
                format: "DD/MM/YYYY HH:mm:ss",
                error: _vm.$v.date_end.$error
              },
              on: { input: _vm.$v.date_end.$touch },
              model: {
                value: _vm.date_end,
                callback: function($$v) {
                  _vm.date_end = $$v
                },
                expression: "date_end"
              }
            })
          ],
          1
        ),
        _c(
          "div",
          { staticClass: "col-12" },
          [
            _c("q-select", {
              ref: "timezone",
              attrs: {
                options: _vm.timezones,
                "float-label": _vm.$t("timezone"),
                filter: "",
                error: _vm.$v.timezone.$error
              },
              on: { input: _vm.$v.timezone.$touch },
              model: {
                value: _vm.timezone,
                callback: function($$v) {
                  _vm.timezone = $$v
                },
                expression: "timezone"
              }
            })
          ],
          1
        )
      ]),
      _c(
        "q-tabs",
        {
          staticClass: "shadow-1",
          attrs: { color: "secondary" },
          model: {
            value: _vm.tab,
            callback: function($$v) {
              _vm.tab = $$v
            },
            expression: "tab"
          }
        },
        [
          _c("q-tab", {
            attrs: {
              slot: "title",
              name: "permissions",
              icon: "fal fa-clipboard-list-check",
              label: _vm.$t("permissions")
            },
            slot: "title"
          }),
          _c(
            "q-tab-pane",
            { staticClass: "q-px-lg q-pb-xl", attrs: { name: "permissions" } },
            [
              _c("div", { staticClass: "row gutter-sm" }, [
                _c(
                  "div",
                  { staticClass: "col-xs-12 col-sm-12" },
                  [
                    _c("q-select", {
                      ref: "area",
                      attrs: {
                        filter: "",
                        "autofocus-filter": "",
                        options: _vm.areas,
                        "float-label": _vm.$t("areas"),
                        error: _vm.$v.area.$error,
                        multiple: "",
                        chips: "",
                        disable: _vm.disableFields
                      },
                      on: { input: _vm.$v.area.$touch },
                      model: {
                        value: _vm.area,
                        callback: function($$v) {
                          _vm.area = $$v
                        },
                        expression: "area"
                      }
                    })
                  ],
                  1
                ),
                _c("div", { staticClass: "col-xs-12 col-sm-12" }, [
                  _c("p", { staticClass: "caption" }, [
                    _vm._v(_vm._s(_vm.$t("profiles")))
                  ]),
                  _c(
                    "div",
                    { staticClass: "row gutter-sm" },
                    [
                      _c(
                        "div",
                        { staticClass: "col-xs-12 col-sm-12" },
                        [
                          _c("q-checkbox", {
                            attrs: {
                              val: true,
                              label: _vm.$t("all"),
                              disable: _vm.disableFields
                            },
                            on: {
                              input: function($event) {
                                return _vm.checkAll()
                              }
                            },
                            model: {
                              value: _vm.all_profiles,
                              callback: function($$v) {
                                _vm.all_profiles = $$v
                              },
                              expression: "all_profiles"
                            }
                          })
                        ],
                        1
                      ),
                      _vm._l(_vm.profiles, function(item, index) {
                        return _c(
                          "div",
                          {
                            key: index,
                            staticClass: "col-xs-12 col-sm-4",
                            class: _vm.getErrorClass(_vm.$v.profile.$error)
                          },
                          [
                            _c("q-checkbox", {
                              ref: "profile",
                              refInFor: true,
                              attrs: {
                                "keep-color": "",
                                val: item.value,
                                label: item.label,
                                color: _vm.getErrorColor(_vm.$v.profile.$error),
                                disable: _vm.disableFields
                              },
                              on: { input: _vm.$v.profile.$touch },
                              model: {
                                value: _vm.profile,
                                callback: function($$v) {
                                  _vm.profile = $$v
                                },
                                expression: "profile"
                              }
                            })
                          ],
                          1
                        )
                      })
                    ],
                    2
                  )
                ])
              ]),
              _c("div", { staticClass: "row gutter-sm" }, [
                _c(
                  "div",
                  { staticClass: "col-xs-12 col-sm-12" },
                  [
                    _c("q-select", {
                      ref: "user_group",
                      attrs: {
                        options: _vm.user_groups,
                        "float-label": _vm.$t("groups"),
                        error: _vm.$v.user_group.$error,
                        multiple: "",
                        chips: "",
                        disable: _vm.disableFields
                      },
                      on: { input: _vm.$v.user_group.$touch },
                      model: {
                        value: _vm.user_group,
                        callback: function($$v) {
                          _vm.user_group = $$v
                        },
                        expression: "user_group"
                      }
                    })
                  ],
                  1
                )
              ])
            ]
          )
        ],
        1
      ),
      _c(
        "q-card",
        { staticClass: "q-mt-md" },
        [
          _c("q-card-title", [
            _vm._v(
              "\n            " +
                _vm._s(_vm.$t("recipients")) +
                " (" +
                _vm._s(_vm.users.length) +
                ")\n        "
            )
          ]),
          _c("q-card-separator"),
          _c(
            "q-card-main",
            { staticClass: "relative-position" },
            [
              _c(
                "q-scroll-area",
                { staticStyle: { width: "100%", height: "300px" } },
                [
                  _c(
                    "div",
                    { staticClass: "row gutter-sm q-mt-sm" },
                    _vm._l(_vm.users, function(user, index) {
                      return _c(
                        "div",
                        { key: index, staticClass: "col-xs-12 col-sm-4" },
                        [
                          _vm._v(
                            "\n                        " +
                              _vm._s(user.full_name)
                          ),
                          _c("br"),
                          _c("span", { staticClass: "text-faded" }, [
                            _vm._v(_vm._s(user.email))
                          ]),
                          _c("br"),
                          _vm.status === 2
                            ? _c("span", { staticClass: "text-faded" }, [
                                _vm._v(_vm._s(_vm.$t("opened_in")) + ": ")
                              ])
                            : _vm._e(),
                          !user.opened_date && _vm.status === 2
                            ? _c("span", { staticClass: "text-negative" }, [
                                _vm._v("-")
                              ])
                            : _vm._e(),
                          user.opened_date && _vm.status === 2
                            ? _c("span", { staticClass: "text-positive" }, [
                                _vm._v(_vm._s(_vm.fDate(user.opened_date)))
                              ])
                            : _vm._e()
                        ]
                      )
                    }),
                    0
                  ),
                  _c(
                    "q-inner-loading",
                    {
                      staticStyle: { width: "100%", height: "300px" },
                      attrs: { visible: _vm.loading_users }
                    },
                    [
                      _c("q-spinner-dots", {
                        attrs: { size: 100, color: "secondary" }
                      })
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      ),
      _c("div", { staticClass: "row gutter-sm justify-end q-mt-lg" }, [
        _c(
          "div",
          { staticClass: "col-xs-12 col-sm-3", class: _vm.getOrder("cancel") },
          [
            _c("q-btn", {
              staticClass: "full-width",
              attrs: {
                color: "tertiary",
                label: _vm.$t("back"),
                icon: "far fa-chevron-left"
              },
              on: {
                click: function($event) {
                  return _vm.$router.push({ name: "schedules" })
                }
              }
            })
          ],
          1
        ),
        _c(
          "div",
          { staticClass: "col-xs-12 col-sm-3", class: _vm.getOrder("save") },
          [
            _c("q-btn", {
              staticClass: "full-width",
              attrs: {
                color: "secondary",
                label: _vm.$t("save"),
                icon: "far fa-save",
                disable: _vm.disableFields
              },
              on: {
                click: function($event) {
                  return _vm.saveData()
                }
              }
            })
          ],
          1
        )
      ])
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }